import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import {Observable} from 'rxjs';
import { GenericDocHdrContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { BasicApiResponseModel } from '../../shared/api-response.model';


@Injectable({
  providedIn: 'root'
})
export class GenericDocHdrService extends BaseApiTemplateService<GenericDocHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
  Core2Config.ERP_PREFIX + 'generic-doc/hdrs';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/hdrs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/hdrs';
    this.httpClient = http;
  }

  public getByGuidLoginConsolidatedArap(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<GenericDocHdrContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.LOGIN_CONSOLIDATED_ARAP_EP_SUFFIX;
    }
    return this.httpClient.get<BasicApiResponseModel<GenericDocHdrContainerModel>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }
}
